import {useSelectedDocContext} from '../../search-hooks';
import React from 'react';
import {DocPreviewRow} from './doc-preview-section/docPreviewRow';

export const SearchPreview = React.memo(() => {
    const selectedDoc = useSelectedDocContext();
    return (
        <div id={'search-preview'}>
            <DocPreviewRow selectedDocument={selectedDoc}></DocPreviewRow>
        </div>
    );
});
